module.exports = __webpack_public_path__ + "static/media/cheesesteak-noodles2.98d87355.png";